import { createContext, useContext, useState } from "react";

import moment from "moment-timezone";

const initialState = {
  platformFilter: "all",
  setPlatformFilter: () => {},

  breakdowns: ["daily"],
  setBreakdowns: () => {},

  tableBreakdowns: ["daily"],
  setTableBreakdowns: () => {},

  adPlacements: [],
  setAdPlacements: () => {},

  selectedIncomes: [],
  setSelectedIncomes: () => {},

  startDate: moment().subtract(7, "days").format("DD.MM.YYYY"),
  setStartDate: () => {},

  endDate: moment().subtract(0, "days").format("DD.MM.YYYY"),
  setEndDate: () => {},
};

const SiteBreakdownAndFiltersContext = createContext(initialState);

export function useSiteBreakdownAndFilters() {
  const context = useContext(SiteBreakdownAndFiltersContext);

  if (!context) {
    throw new Error(
      "Please use useSiteBreakdownAndFilters under SiteBreakdownAndFiltersProvider"
    );
  }

  return context;
}

export default function SiteBreakdownAndFiltersProvider({ children }) {
  const [platformFilter, setPlatformFilter] = useState(
    initialState.platformFilter
  );
  const [breakdowns, setBreakdowns] = useState(initialState.breakdowns);
  const [tableBreakdowns, setTableBreakdowns] = useState(
    initialState.breakdowns
  );
  const [adPlacements, setAdPlacements] = useState(initialState.adPlacements);
  const [selectedIncomes, setSelectedIncomes] = useState(
    initialState.selectedIncomes
  );

  const [startDate, setStartDate] = useState(initialState.startDate);
  const [endDate, setEndDate] = useState(initialState.endDate);

  const onDateRangeChange = (range) => {
    if (typeof range === "undefined") {
      return;
    }
    const dates = {};
    switch (range) {
      case "LH":
        dates.startDate = moment().format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "T":
        dates.startDate = moment().format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "Y":
        dates.startDate = moment().subtract(1, "days").format("DD.MM.YYYY");
        dates.endDate = moment().subtract(1, "days").format("DD.MM.YYYY");
        break;
      case "MTD":
        dates.startDate = moment().startOf("month").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "7D":
        dates.startDate = moment().subtract(7, "days").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "30D":
        dates.startDate = moment().subtract(30, "day").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "LM":
        dates.startDate = moment()
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      case "L3M":
        dates.startDate = moment()
          .subtract(3, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      case "L6M":
        dates.startDate = moment()
          .subtract(6, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      default:
        return;
    }
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
  };

  const reset = () => {
    setBreakdowns(initialState.breakdowns);
    setTableBreakdowns(initialState.breakdowns);
    setPlatformFilter("all");
    setAdPlacements([]);
    setStartDate(moment().subtract(7, "days").format("DD.MM.YYYY"));
    setEndDate(moment().subtract(0, "days").format("DD.MM.YYYY"));
    setSelectedIncomes([]);
  };

  return (
    <SiteBreakdownAndFiltersContext.Provider
      value={{
        platformFilter,
        setPlatformFilter,
        breakdowns,
        setBreakdowns,
        tableBreakdowns,
        setTableBreakdowns,
        adPlacements,
        setAdPlacements,
        selectedIncomes,
        setSelectedIncomes,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        onDateRangeChange,
        reset,
      }}
    >
      {children}
    </SiteBreakdownAndFiltersContext.Provider>
  );
}
